import React from 'react';
import { DispatchContent } from './DispatchContent';
import { FabricDispatchContent } from './FabricDispatchContent';
import { LabelDispatchContent } from './LabelDispatchContent';
import { YarnDispatchContent } from './YarnDispatchContent';
import { LOCAL_STORAGE, VENDOR } from '../../../constants';
import { getLocalStorageItem } from '../../../utils';

/**
 * Dispatch - Router component for dispatch module
 *
 * Routes to the appropriate dispatch content component based on vendor type:
 * - fabric/dyeing: FabricDispatchContent
 * - yarn: YarnDispatchContent
 * - label: LabelDispatchContent
 * - finished_goods: YarnDispatchContent (uses YarnDispatchDetail for detail view)
 * - clothing (default): DispatchContent
 *
 * Follows the same pattern as Manufacturing.js router.
 */
export const Dispatch = () => {
  const vendorType = getLocalStorageItem(LOCAL_STORAGE.VENDOR_TYPE);
  const userName = getLocalStorageItem(LOCAL_STORAGE.USERNAME);

  // TEXSHANN EXPORTS uses clothing dispatch (with group dispatch enabled)
  if (userName === 'TEXSHANN EXPORTS') {
    return <DispatchContent />;
  }

  if (vendorType === VENDOR.FABRIC || vendorType === VENDOR.DYE) {
    return <FabricDispatchContent />;
  }

  if (vendorType === VENDOR.YARN) {
    return <YarnDispatchContent />;
  }

  if (vendorType === 'label') {
    return <LabelDispatchContent />;
  }

  if (vendorType === VENDOR.FINISHED_GOODS) {
    return <YarnDispatchContent />;
  }

  // Default: clothing (ESUN)
  return <DispatchContent />;
};
